// Soul Score API Integration
export async function incrementSoulScore(API, token, { amount = 1, source = "message_double_tap", messageId } = {}) {
  const res = await fetch(`${API}/soul/score`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: JSON.stringify({ amount, source, message_id: messageId })
  });
  if (!res.ok) throw new Error("Soul score increment failed");
  return res.json();
}

export async function getSoulScore(API, token) {
  const res = await fetch(`${API}/soul/score`, {
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) }
  });
  if (!res.ok) throw new Error("Fetch soul score failed");
  return res.json();
}

// Sonic Feedback for Soul Score
export function playTapBeep() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = "sine";
    o.frequency.value = 660; // A5-ish
    o.connect(g);
    g.connect(ctx.destination);
    g.gain.setValueAtTime(0.0001, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.1, ctx.currentTime + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.12);
    o.start();
    o.stop(ctx.currentTime + 0.14);
  } catch (e) { 
    console.log('Audio context not available');
  }
}

// Video Montage Integration
export async function createConsciousnessTrailer(API, token, sessionId) {
  const res = await fetch(`${API}/api/montage/create-video-job`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: JSON.stringify({ 
      session_id: sessionId,
      montage_type: "consciousness_trailer",
      theme: "seeker_agent_mission"
    })
  });
  if (!res.ok) throw new Error("Trailer creation failed");
  return res.json();
}